import apiClient from "@/app/api/client";
import type {
	Zone,
	ZoneAssignInput,
	ZoneAssignment,
	ZoneCreateInput,
	ZoneUpdateInput,
} from "../types";

interface SingleZoneResponse {
	success: true;
	data: Zone;
}

interface AssignmentListResponse {
	success: true;
	data: ZoneAssignment[];
}

interface SingleAssignmentResponse {
	success: true;
	data: ZoneAssignment;
}

export const zonesService = {
	async create(input: ZoneCreateInput): Promise<Zone> {
		const response = await apiClient.post<SingleZoneResponse>("/zones", input);
		return response.data.data;
	},

	async update(id: string, input: ZoneUpdateInput): Promise<Zone> {
		const response = await apiClient.patch<SingleZoneResponse>(`/zones/${id}`, input);
		return response.data.data;
	},

	/**
	 * Arxivlash — `POST /zones/{id}/archive`. Qator O'CHMAYDI: `is_active`
	 * `false` bo'ladi va `archived_at` qo'yiladi (spec §3.4). Shuning uchun
	 * javob 204 emas, yangilangan hudud.
	 *
	 * ⚠️ `DELETE /zones/{id}` marshruti YO'Q va bo'lmaydi
	 * (`employee_zones.zone_id` FK'si `ON DELETE restrict`).
	 */
	async archive(id: string): Promise<Zone> {
		const response = await apiClient.post<SingleZoneResponse>(`/zones/${id}/archive`);
		return response.data.data;
	},

	async listAssignments(zoneId: string): Promise<ZoneAssignment[]> {
		const response = await apiClient.get<AssignmentListResponse>(`/zones/${zoneId}/employees`);
		return response.data.data;
	},

	async assign(zoneId: string, input: ZoneAssignInput): Promise<ZoneAssignment> {
		const response = await apiClient.post<SingleAssignmentResponse>(
			`/zones/${zoneId}/employees`,
			input
		);
		return response.data.data;
	},

	/**
	 * ⚠️ HTTP metodi DELETE, lekin amal — YAKUNLASH. `employee_zones`
	 * append-only (spec §3.5): so'rov `valid_to = bugun` qo'yadi va
	 * yangilangan qatorni qaytaradi (marshrut 200, `zones.routes.ts`).
	 * O'tgan oy davomati o'sha davrda amalda bo'lgan biriktirish bo'yicha
	 * hisoblanishi kerak — qator o'chirilsa, qayta hisoblash bugungi holat
	 * bilan bajarilib, natija JIMGINA noto'g'ri chiqardi.
	 *
	 * Shu sabab funksiya nomi `endAssignment`, `remove` EMAS — UI ham
	 * «Yakunlash» deb ko'rsatadi va qator jadvalda qolaveradi.
	 */
	async endAssignment(zoneId: string, assignmentId: string): Promise<ZoneAssignment> {
		const response = await apiClient.delete<SingleAssignmentResponse>(
			`/zones/${zoneId}/employees/${assignmentId}`
		);
		return response.data.data;
	},
};
